import { PageHeader } from '@components/page-header/page-header';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';
import { useProcess } from '@react-query/hooks/query/use-process';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';
import './approver-parent-consent-header.scss';

export const ApproverParentConsentHeader = () => {
    const { data: process, isSuccess } = useProcess();
    const { approverParentConsent } = useTranslation();

    if (!isSuccess) {
        return <PageHeader header={approverParentConsent.headerWithoutName} />;
    }

    return (
        <div className="approver-parent-consent-header">
            <RichIcon
                className="approver-parent-consent-header__rich-icon"
                type={RichIconTypes.FAMILIE}
                maxHeight={190}
            />
            <h1 className="approver-parent-consent-header__title">
                {format(approverParentConsent.header, process.child.name)}
            </h1>
            <p className="approver-parent-consent-header__ingress">
                {format(approverParentConsent.ingress, process.applicantParent.name, process.child.name)}
            </p>
        </div>
    );
};
